import { FC, SVGProps } from 'react'

interface BlueGemIconProps extends SVGProps<SVGSVGElement> {
  size?: number
}

/**
 * 注意: 后续使用宝石图标推荐使用 GemIcon.tsx 组件，通过传入 colorType 属性控制宝石的颜色
 * 这样可以保持图标样式一致性，GemIcon支持'red'和'blue'两种颜色类型
 *
 * 相关文件: {@link ./GemIcon.tsx}
 */
export const BlueGemIcon: FC<BlueGemIconProps> = ({ size = 31, ...props }) => {
  return (
    <svg
      width={size}
      height={size * (44 / 31)} // 保持纵横比
      viewBox="0 0 31 44"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>2.2</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-283.000000, -471.000000)">
          <g transform="translate(285.000000, 473.000000)">
            <path
              d="M0,10.1 C0,9.56956 0.207643796,9.06086 0.577228467,8.68578 L8.55898029,0.58578 C8.92858467,0.21072 9.42985839,0 9.95255474,0 L17.0474453,0 C17.5701022,0 18.0714745,0.21072 18.441,0.58578 L26.4227518,8.68578 C26.7922774,9.06086 27,9.56956 27,10.1 L27,29.9 C27,30.4304 26.7922774,30.9392 26.4227518,31.3142 L18.441,39.4142 C18.0714745,39.7892 17.5701022,40 17.0474453,40 L9.95255474,40 C9.42985839,40 8.92858467,39.7892 8.55898029,39.4142 L0.577228467,31.3142 C0.207643796,30.9392 0,30.4304 0,29.9 L0,10.1 Z"
              stroke="#B0CFFF"
              strokeWidth="4"
              fill="#6583E9"
              fillRule="nonzero"
              strokeLinejoin="round"
            ></path>
            <polygon
              fill="#8BA2EE"
              fillRule="nonzero"
              points="1.97080292 29.9 1.97080292 10.1001 8.62226277 12.3501 8.62226277 27.65"
            ></polygon>
            <polygon
              fill="#C1E4FF"
              fillRule="nonzero"
              points="9.95255474 2 1.97080292 10.1 8.62226277 12.35002 13.5 6.5 17.0474453 2"
            ></polygon>
            <polygon
              fill="#4E4FD7"
              fillRule="nonzero"
              points="18.3773431 27.65 13.4996058 33.5 9.95216058 38 17.0470511 38 25.0288029 29.9 25.0288029 10.1 17.0470511 2 13.4996058 6.5 18.3773431 12.35"
            ></polygon>
            <polygon
              fill="#592FAC"
              fillRule="nonzero"
              points="25.0295912 10.1001 25.0295912 29.9 18.3781314 27.65 18.3781314 12.3501"
            ></polygon>
            <g
              transform="translate(21.035956, 11.449700)"
              fill="#533BB4"
              fillRule="nonzero"
            >
              <ellipse cx="2.21675912" cy="3.15" rx="1" ry="1"></ellipse>
              <ellipse cx="1.10778832" cy="6.9753" rx="1" ry="1"></ellipse>
              <ellipse cx="2.66058394" cy="5.8503" rx="1" ry="1"></ellipse>
              <ellipse cx="0.443430657" cy="4.5003" rx="1" ry="1"></ellipse>
              <ellipse cx="2.66058394" cy="0.45" rx="1" ry="1"></ellipse>
              <ellipse cx="2.66058394" cy="11.2503" rx="1" ry="1"></ellipse>
              <ellipse cx="2.66058394" cy="9.0003" rx="1" ry="1"></ellipse>
            </g>
            <polygon
              fill="#6495FF"
              fillRule="nonzero"
              points="8.62226277 12.35 8.62226277 27.65 13.5 33.5 18.3777372 27.671 18.3777372 12.35 13.5 6.5"
            ></polygon>
            <polygon
              fill="#9BB8FF"
              fillRule="nonzero"
              points="8.62226277 27.65 8.62226277 12.35 13.5 6.5 18.3777372 12.35"
            ></polygon>
            <polyline
              stroke="#D5E7FF"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="13.5003942 7.8501 9.50951825 12.8001 9.50951825 22.25"
            ></polyline>
            <line
              x1="2.85805839"
              y1="11.4502"
              x2="2.85805839"
              y2="28.5502"
              stroke="#C1E4FF"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="3.74529416"
              y1="9.6499"
              x2="10.3967737"
              y2="2.8999"
              stroke="#FFE7F2"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <g
              transform="translate(16.601650, 29.900000)"
              fill="#533BB4"
              fillRule="nonzero"
            >
              <ellipse cx="5.09945255" cy="1.125" rx="1" ry="1"></ellipse>
              <ellipse cx="0.665145985" cy="5.625" rx="1" ry="1"></ellipse>
              <ellipse cx="2.43965693" cy="3.8248" rx="1" ry="1"></ellipse>
              <ellipse cx="0.443430657" cy="2.7" rx="1" ry="1"></ellipse>
              <ellipse cx="3.54783942" cy="2.7" rx="1" ry="1"></ellipse>
              <ellipse cx="2.21675912" cy="0.9" rx="1" ry="1"></ellipse>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
